export default "__VITE_ASSET__BE9DHoI1__"